import { render, staticRenderFns } from "./FacebookPagesCard.vue?vue&type=template&id=35302b80&scoped=true"
import script from "./FacebookPagesCard.vue?vue&type=script&lang=js"
export * from "./FacebookPagesCard.vue?vue&type=script&lang=js"
import style0 from "./FacebookPagesCard.vue?vue&type=style&index=0&id=35302b80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35302b80",
  null
  
)

export default component.exports